
import Vue from 'vue';
import { ClubOffer } from '@run-diffusion/shared';
import { getPercentOffFigure } from '@/views/Runnits/pages/RunnitsSubscriptionsPage/utils';

/**
 * Controlled monthly/yearly radio. Purely presentational — it renders `value` and emits `input`,
 * nothing else. The default for a user who has not chosen yet is derived by the parent page's
 * `isMonthly` computed, deliberately NOT by a watcher in here: the previous version watched `user`
 * and pushed a query param on mount, which lost the race whenever this component rendered before
 * user.clubOffer resolved, leaving the page stuck on yearly.
 */
export default Vue.extend({
	name: 'IsMonthlySwitch',
	props: {
		value: { type: Boolean, required: true },
		clubOffers: { type: Array, default: () => [] },
	},
	computed: {
		percentOffText () {
			let minPercentOff: number = null;
			let maxPercentOff: number = null;
			(this.clubOffers || []).forEach((clubOffer: ClubOffer) => {
				if (!clubOffer.stripe) return;
				const curr: number = getPercentOffFigure(clubOffer.stripe.monthlyPriceAmount, clubOffer.stripe.yearlyPriceAmount);
				if (!minPercentOff || curr < minPercentOff) minPercentOff = curr;
				if (!maxPercentOff || curr > maxPercentOff) maxPercentOff = curr;
			});
			if (maxPercentOff && maxPercentOff !== minPercentOff) {
				return `(Save up to ${maxPercentOff}%)`;
			}
			if (maxPercentOff && maxPercentOff === minPercentOff) {
				return `(Save ${maxPercentOff}%)`;
			}
			return null;
		},
	},
	methods: {
		onInput (val: boolean) {
			this.$emit('input', !!val);
		},
	},
});
